// extracted by mini-css-extract-plugin
module.exports = {"root":"aad0e81037f452705626493354cd5950"};